module.exports = __webpack_public_path__ + "img/box-ape.95acac86.png";